/**
 * Формирует строку из массива с деталями ошибки.
 *
 * @param detail - Массив, содержащий информацию об ошибке.
 * @returns  Строка, составленная из ошибок.
 */
export const getErrorDetailsText = (details) => {
    if (!(details === null || details === void 0 ? void 0 : details.length)) {
        return '';
    }
    return details.map(detail => `${detail.label}: ${detail.value}`).join(', ');
};
